<template>
  <div>
    <h4 class="mb-4 text-large-copy">
      Share this page
    </h4>
    <EmailIcon
      class="mr-2 inline-block size-14 cursor-pointer rounded-[50%] bg-rust-75 p-2 *:!fill-white hover:bg-rust-100"
      @click="shareEmail"
    />
    <FacebookIcon
      class="mr-2 inline-block size-14 cursor-pointer rounded-[50%] bg-blue-75 p-2  *:!fill-white hover:bg-blue-100"
      @click="shareFacebook"
    />
    <XTwitterIcon
      class="mr-2 inline-block size-14 cursor-pointer rounded-[50%] bg-green-75 p-2 *:!fill-white hover:bg-green-100"
      @click="shareTwitter"
    />
  </div>
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

import EmailIcon from "~/assets/svgs/social/email.svg";
import FacebookIcon from "~/assets/svgs/social/facebook.svg";
import XTwitterIcon from "~/assets/svgs/social/xtwitter.svg";

const props = defineProps<{
  metadata: Content.ArticlesDocumentData | undefined;
}>();

const config = useRuntimeConfig();
const route = useRoute();

const title = props.metadata?.meta_title
  ? encodeURIComponent(props.metadata.meta_title)
  : props.metadata?.title
    ? encodeURIComponent(props.metadata.title)
    : "";

const shareEmail = () => {
  const share_url = `mailto:?subject=Wanted to share this link with you.&body=I found an article I think you will like: ${config.public.BASE_URL}${route.fullPath}.`;
  window.open(share_url);
};
const shareTwitter = () => {
  const share_url = `https://www.twitter.com/share?url=${config.public.BASE_URL}${route.fullPath}&text=${title}`;
  window.open(share_url);
};
const shareFacebook = () => {
  const share_url = `https://www.facebook.com/share.php?u=${config.public.BASE_URL}${route.fullPath}`;
  window.open(share_url);
};
</script>
